import React from "react";
import { CourseCreateProvider } from "./CourseCreateContext";
import { BaseInformationFormSchema, BaseInformationStep } from "./BaseInformation/BaseInformationStep";
import { CourseConfigurationTabs } from "./CourseConfigurationTabs";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";
import { PageMain } from "components/molecules";
import { coursesApi } from "api";
import { getApiErrorMessage, useToaster } from "utils";
import { useNavigate } from "react-router-dom";

export const CourseCreatePage = (): JSX.Element => {
  const { showSuccess, showError } = useToaster();
  const navigate = useNavigate();

  const onSubmit = async (data: BaseInformationFormSchema) => {
    try {
      const response = await coursesApi.create(data);
      showSuccess("Utworzono kurs.");
      navigate(`${routes.COURSES_EDIT(response.data.data.id)}/${routes.COURSES_EDIT_SESSION}`);
    } catch (e) {
      console.error(e);
      showError(getApiErrorMessage(e, "Wystąpił błąd podczas zapisywania zmian."));
    }
  };

  return (
    <CourseCreateProvider>
      <PageMain>
        <PaziaBreadcrumbs segments={[{ title: "Kursy", path: routes.COURSES }, { title: "Tworzenie kursu" }]} />
        <CourseConfigurationTabs />
        <BaseInformationStep onSubmit={onSubmit} />
      </PageMain>
    </CourseCreateProvider>
  );
};
